import { environmentConfig } from "@src/appV2/environment";
import request from "superagent";

import { getAuthHeader } from "../superagent";

export const getZendeskJWTMessagingSDK = async (): Promise<string> => {
  const token = (await getAuthHeader()).Authorization;
  const { text } = await request.get(
    `${environmentConfig.REACT_APP_ZENDESK_JWT_MICROSERVICE_BASE_URL}/zendesk/sdk/jwt-messaging/${token}`
  );
  return text;
};
